import { msg } from '@lingui/core/macro';
import { APP_PATHS } from 'app-shared/constants';
import { IconFolder, IconHome } from 'app-ui/icon';

import { type NavigationItem } from '@/navigation/types/NavigationItem';

// The main pages, in drawer order. To add a page: add its path to APP_PATHS,
// its route to AppRouter, and an entry here. The drawer, the command menu and
// the go-to shortcuts all read this list.
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'home',
    label: msg`Home`,
    Icon: IconHome,
    path: APP_PATHS.home,
    goToHotkey: 'g h',
  },
  {
    id: 'projects',
    label: msg`Projects`,
    Icon: IconFolder,
    path: APP_PATHS.projects,
    goToHotkey: 'g p',
  },
];
